export const DOCUMENT_FILTER_OPTIONS = [
  { id: "all", label: "All" },
  { id: "receipt", label: "Receipts" },
  { id: "report", label: "Reports" },
  { id: "certificate", label: "Certificates" },
];

export const resolveDocumentCategory = (doc) => {
  const stored = String(doc?.document_category || "").toLowerCase().trim();
  if (stored && stored !== "other") return stored;

  const title = String(doc?.title || "").toLowerCase();
  if (/(receipt|payment)/i.test(title)) return "receipt";
  if (/(certificate|cert)/i.test(title)) return "certificate";
  if (/(report|admission|form)/i.test(title)) return "report";
  if (doc?.resource_type === "image") return "photo";
  return "other";
};

export const filterDocuments = (documents, { search = "", category = "all" } = {}) => {
  const term = search.trim().toLowerCase();
  return (Array.isArray(documents) ? documents : []).filter((doc) => {
    const docCategory = resolveDocumentCategory(doc);
    if (category !== "all" && docCategory !== category) return false;
    if (!term) return true;
    return String(doc.title || "").toLowerCase().includes(term);
  });
};

export const sortDocuments = (documents, sortBy = "latest") => {
  const list = [...(Array.isArray(documents) ? documents : [])];
  if (sortBy === "oldest") {
    return list.sort(
      (a, b) =>
        (a.display_order ?? 0) - (b.display_order ?? 0) ||
        String(a.id).localeCompare(String(b.id)),
    );
  }
  if (sortBy === "name") {
    return list.sort((a, b) =>
      String(a.title || "").localeCompare(String(b.title || ""), undefined, {
        sensitivity: "base",
      }),
    );
  }
  // latest (default): display_order desc, then id desc
  return list.sort(
    (a, b) =>
      (b.display_order ?? 0) - (a.display_order ?? 0) ||
      String(b.id).localeCompare(String(a.id)),
  );
};
